import React, { useContext, useEffect } from 'react'
import { GeneralContext } from '../../context/'
import {
    Container,
} from "reactstrap"

import { withRouter } from 'react-router-dom'
import DataTable from './components/Datatable'

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Marcas`,
            parentLink: '/brands',
            item: `Marcas`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DataTable />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
